export default function Footer({ t }) {
  return (
    <footer>
      <div className="footer-logo">A<span>2</span>G</div>
      <ul className="footer-links">
        <li><a href="#videos">{t.nav_videos}</a></li>
        <li><a href="#how">{t.nav_how}</a></li>
        <li><a href="#inquiry">{t.nav_inquiry}</a></li>
        <li><a href="mailto:contact@asiatoglobal.com">contact@asiatoglobal.com</a></li>
      </ul>
      <div className="footer-copy">© 2026 A2G. All rights reserved.</div>
    </footer>
  )
}
